import React from 'react';
import './Productcard.css';
import Bgimg from '../bgfix/Bgimg';

const ProductCard = ({ product, addToCart }) => {
  const [isFav, setIsFav] = React.useState(false);

  // ✅ Safe return if product is undefined
  if (!product) return null;

  return (
    <>
    <div className="product-card card h-100 border-0">
      {product.badge && <span className="product-badge">{product.badge}</span>}
      <div className="product-image-wrap">
        <img
          src={product.image}
          className="card-img-top product-image"
          alt={product.name}
          loading="lazy"
        />
        <button
          className={`btn btn-wishlist ${isFav ? 'active' : ''}`}
          onClick={() => setIsFav((v) => !v)}
          type="button"
        >
          {isFav ? '♥' : '♡'}
        </button>
      </div>
      <div className="card-body d-flex flex-column">
        <h3 className="card-title product-title">{product.name}</h3>
        <div className="product-rating mb-2">★★★★☆ <span className="text-muted small">(4.5)</span></div>
       
        {/* <p className="card-text text-muted product-desc">{product.description}</p> */}
        {/* <div className="mt-auto">
          <div className="price-container">
            <span className="current-price me-2">{product.price}</span>
            {product.originalPrice && (
              <span className="original-price">{product.originalPrice}</span>
            )}
          </div>
          <button
            className="btn btn-success w-100 mt-3 btn-add-to-cart"
            onClick={() => addToCart(product)}
          >
            Add to Cart 🛒
          </button>
        </div> */}

      </div>
    </div>

    </>
  );
};

export default ProductCard;
